import { Result } from 'neverthrow';

import { put } from '../../Network';

import { getResultOfUploadHttpAction } from './internals.common';
import MediaUploadError from './MediaUploadError';
import UploadTask from './UploadTask';

export async function uploadFile(
  uploadTask: UploadTask,
  url: string
): Promise<Result<true, MediaUploadError>> {
  const { type: mediaType, file } = uploadTask.file;
  const res = await put<unknown>(url, file, {
    onUploadProgress: (e) => {
      // @ts-expect-error: Suppressing error to support legacy code
      const percentDone = Math.round((e.loaded / e.total) * 100);
      uploadTask.updateProgress(percentDone);
    },
  });
  return getResultOfUploadHttpAction(res, `${mediaType} upload to S3`);
}
